module.exports = __webpack_public_path__ + "static/media/3DPPA17.b35485fb.jpg";